module.exports = __webpack_public_path__ + "static/media/wide.a57375ff.jpg";